import { useEffect, useState } from "react";
import { IValueAndLabel } from "../../customTypings/common/ValueAndLabel";
import { calendarEventService, userService } from "../../services";

export const useCalendarData = () => {
  const [allAppointmentTypes, setAllAppointmentTypes] = useState<IValueAndLabel[]>();
  const [allIdentities, setAllIdentities] = useState<IValueAndLabel[]>();

  useEffect(() => {
    calendarEventService
      .getAllAppointmentTypeListItems()
      .then((appointmentTypes: any) => setAllAppointmentTypes(appointmentTypes));

    userService
      .getAllListItems()
      .then((identities: any) => setAllIdentities(identities));
  }, []);

  return {
    allAppointmentTypes,
    allIdentities,
  };
};
